import Footer from "../components/common/footer";
import { Helmet } from "react-helmet";
import HeaderTwo from "../components/common/headerTwo";
import Hero from "../components/about/hero";
import Experts from "../components/about/experts";
import Honest from "../components/about/honest";
import Eq from "../components/about/eq";
import Faq from "../components/home/faq";
import Cta from "../components/about/cta";
import Help from "../components/about/about";

function About() {
  return (
    <>
      <Helmet>
        <title>O nas | Drzewus</title>
        <meta name="title" content="Kontakt | Drzewus" />
        <meta
          name="description"
          content="Świadczymy kompleksowe usługi ogrodnicze, w tym projektowanie ogrodów, pielęgnację zieleni, wycinkę drzew i krzewów oraz nawadnianie."
          key="desc"
        />
        <meta property="og:title" content="O nas | Drzewus" />
        <meta
          property="og:description"
          content="Świadczymy kompleksowe usługi ogrodnicze, w tym projektowanie ogrodów, pielęgnację zieleni, wycinkę drzew i krzewów oraz nawadnianie."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/path/to/og-image.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Hero />
        <Help />
        <Experts />
        <Honest />
        <Eq />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </>
  );
}
export default About;
